import { SPECIALTYMAPPING } from './constants/specialtymapping_c';

import _v from './vars';
import _u from './util';
import _t from './templates/templates_t';

let checkedForFeatured = [];

function bindCommentCtPop() { // First run, wait for both Top Article + Feed, then run on each feed page afterwards
	document.removeEventListener('feedAndTopLoaded', bindCommentCtPop);
	commentCtPop();
	document.addEventListener('feedLoaded', commentCtPop);
}

/* function bindFeaturedComment() {
	document.querySelectorAll('.hasComments').forEach(function(element){
		if (_u.getClosest(element, '.pers-feed-item, .pers-article-item').classList.contains('pers-article-item')) {
			return; // Apply to Feed Cards only for now, not Top Article
		}
		let artId = element.querySelector('.livefyre-commentcount').getAttribute("data-lf-article-id");
		if (checkedForFeatured.indexOf(artId) == -1) {
			checkedForFeatured.push(artId);

			_u.apiGet('https://' + _v.lfNetworkName + '.bootstrap.fyre.co/bs3/v3.1/' + _v.lfNetworkName + '.fyre.co/' + _v.siteID + '/'+ btoa(artId) +'/init', true).then(comments => {				
				if (comments && comments.featured) {
					let commentData = {};
					let key = Object.keys(comments.featured.authors);

					let specialtyID = comments.featured.authors[key].tags[0].split('%')[0];
					commentData.specialtyName = '';
					if (specialtyID > 0) {
						commentData.specialtyName = SPECIALTYMAPPING[specialtyID];
					}

					commentData.userName =  comments.featured.authors[key].displayName;

					let desc = comments.featured.content[0].content.bodyHtml.replace( /(<([^>]+)>)/ig, '');
					commentData.featuredCommentsDescription = desc;
					
					let currCard = _u.getClosest(element, '.pers-feed-item');
					currCard.classList.add('has-featured-comment');
					currCard.appendChild(_u.strToDom(_t.featuredComment(commentData)));		
					
					currCard.querySelector('.featured-show-more').addEventListener('click', function(e){
						e.preventDefault();
						e.stopPropagation();
						wmdTrack('fy-featuredcomment_showmore', this);
						location.href = currCard.getAttribute('href');
					});
					
				}
			});
			
		}			
	});
} */

function commentCtPop() {
    try {
		window.vfCommentCount();
    }
    catch (e) { console.log(e); }
}

document.addEventListener('feedAndTopLoaded', bindCommentCtPop);